module.exports = __webpack_public_path__ + "static/media/thai-chile-chocolate-stout.f0bae684.webp";